import React from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, SearchSelect } from "../../..";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "no-wrap",
      padding: "20px"
    },
    flex: {
      display: "flex"
    },
    mr30: {
      "margin-right": "30px",
      width: "100%"
    }
  };
});

var ClientForm = function ClientForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      onChange = _ref.onChange,
      translation = _ref.translation;
  // console.log('translation.selects.client_type.items', translation.selects.client_type.items);
  var classes = useStyles();
  var clientTypes = [{
    value: "school",
    label: "School"
  }, // { value: 'school', label: userContext.translation.language.school },
  {
    value: "publicAdmin",
    label: "Public Administration"
  }, {
    value: "company",
    label: "Company"
  } // { value: "user", label: "Usuario" }
  ];
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "city",
    name: "city",
    key: "city",
    label: translation ? translation.inputs.contact_city : "City",
    component: TextField,
    className: classes.mr30,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "client-type",
    name: "clientType",
    key: "clientType",
    className: classes.mr30,
    component: SearchSelect,
    margin: "normal",
    value: values.clientType,
    options: translation ? translation.selects.client_type.items : clientTypes,
    placeholder: translation ? translation.selects.client_type.placeholder : "Client type",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "email",
    name: "email",
    key: "email",
    label: translation ? translation.inputs.contact_email : "Email",
    component: TextField,
    className: classes.mr30,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "phone",
    name: "telephone",
    key: "telephone",
    label: translation ? translation.inputs.contact_phone : "Phone number",
    component: TextField,
    className: classes.mr30,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "web",
    name: "web",
    key: "web",
    label: translation ? translation.inputs.contact_web : "Web",
    component: TextField,
    className: classes.mr30,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })));
};

ClientForm.defaultProps = {
  mode: "add"
};
export { ClientForm };